export default __webpack_public_path__ + "images/0x28f1d1c509495e5afc23fb47acf6cc5b217ab598.png";